var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667L14.12.787 8 6.893 1.88.787 0 2.667l8 8 8-8z",
    fill: "currentColor"
  })));
}
export default SvgArrowDown;